export default "__VITE_ASSET__BhC5KKsq__"